import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  const isGuoman = comic.type === 'guoman';
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-xl bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
      aria-label={`《${comic.title}》详情`}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {comic.tag && (
          <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
            {comic.tag}
          </span>
        )}
        <span
          className={`absolute right-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium text-background-50 ${
            comic.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500'
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h4 className="truncate font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h4>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {comic.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className={`rounded-full px-2 py-0.5 text-xs ${
                isGuoman ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-800'
              }`}
            >
              {g}
            </span>
          ))}
        </div>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
          <span>{comic.views} 人气</span>
          <span>{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}